import React from "react";

const Documents = ({ Documents = [] }) => {
  return (
    <div className="py-5 ">
      <div className="mt-5">
        <div className="mt-5 md:px-10">
          {Documents.length > 0 && (
            <ul className="space-y-3 list-disc mt-4 pl-4 text-sm text-gray-800">
              {Documents.map((Document, index) => (
                <React.Fragment key={index}>
                  <li
                    className="hidden md:flex items-start text-left "
                  >
                    <a
                      href={Document.pdfUrl}
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Document.title}
                    </a>
                    <p>&ensp; {`(${Document.size} MB)`}</p>
                  </li>
                  <li
                    className="flex md:hidden items-start text-left "
                    key={index}
                  >
                    <a
                      href={Document.pdfUrl}
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Document.pdfUrl.length > 30
                        ? `${Document.pdfUrl.substring(0, 20)}...`
                        : Document.pdfUrl}
                    </a>
                    <p>&ensp; {`(${Document.size} MB)`}</p>
                  </li>

                  <br />
                </React.Fragment>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Documents;
